!function() {
  var e = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {}, t = {}, n = {}, i = e.parcelRequire5f74;
  null == i && ((i = function(e) {
    if (e in t) return t[e].exports;
    if (e in n) {
      var i = n[e];
      delete n[e];
      var a = {
        id: e,
        exports: {}
      };
      return t[e] = a, i.call(a.exports, a, a.exports), a.exports;
    }
    var s = new Error("Cannot find module '" + e + "'");
    throw s.code = "MODULE_NOT_FOUND", s;
  }).register = function(e, t) {
    n[e] = t;
  }, e.parcelRequire5f74 = i), (0, i.register)("gjV2B", function(e, t) {
    var n, i, a, s;
    n = e.exports, i = "debounce", a = function() {
      return o;
    }, Object.defineProperty(n, i, {
      get: a,
      set: s,
      enumerable: !0,
      configurable: !0
    });
    const o = (e, t) => {
      let n;
      const i = (...i) => {
        clearTimeout(n), n = setTimeout(() => {
          clearTimeout(n), e(...i);
        }, t);
      };
      return i.cancel = () => {
        clearTimeout(n), n = null;
      }, i;
    };
  });
  var a = i("gjV2B");
  (() => {
    if (customElements.get("cart-gift-note")) return;
    customElements.define("cart-gift-note", class extends HTMLElement {
      constructor() {
        super(), this.cart = {}, this.initialNote = "", this.restoreTimeout = null, this.elements = {
          checkbox: this.querySelector('input[type="checkbox"]#CartGiftNoteToggle'),
          accordion: this.querySelector('[id^="CollapsibleAccordion-"]'),
          textarea: this.querySelector("textarea"),
          toggle: this.querySelector("[data-toggle]"),
          cancel: this.querySelector("[data-cancel]"),
          save: this.querySelector("[data-save]"),
          cart: this.closest("shopping-cart"),
          headerCount: this.querySelector("[data-header-count]")
        }, this.handleInputChange = (0, a.debounce)(this.handleInputChange.bind(this), 100), 
        this.handleSaveClick = this.handleSaveClick.bind(this), this.handleCartUpdate = this.handleCartUpdate.bind(this), 
        this.handleToggleChange = this.handleToggleChange.bind(this);
      }
      connectedCallback() {
        this.elements.textarea && (this.initialNote = this.elements.textarea.value, this.cart.note = this.initialNote, 
        this.addEventListeners(), this.updateAccordionInert(), this.hideSaveButton(), this.updateUIText());
      }
      disconnectedCallback() {
        this.removeEventListeners();
      }
      handleInputChange() {
        const {textarea: e} = this.elements, t = this.cart.note || this.initialNote || "";
        e.value.trim() !== t ? this.showSaveButton() : this.hideSaveButton(), this.updateUIText();
      }
      handleToggleChange() {
        this.updateAccordionInert(), this.elements.checkbox.checked || (this.elements.textarea.value = this.cart.note || this.initialNote || "", 
        this.hideSaveButton(), this.updateUIText());
      }
      async handleSaveClick() {
        const {save: e, textarea: t} = this.elements, n = t.value.trim(), i = window.strings || {};
        this.restoreTimeout && clearTimeout(this.restoreTimeout), e.setAttribute("disabled", "true"), 
        e.dataset.originalText = e.textContent, e.textContent = i.saving || "Saving", document.dispatchEvent(new CustomEvent("spinner:show", {
          detail: {
            source: "shopping-cart"
          }
        }));
        try {
          const t = await fetch(`${Shopify.routes.root}cart/update.js`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              note: n
            })
          });
          if (!t.ok) throw new Error("Note update failed");
          const a = await t.json();
          this.cart = a, this.initialNote = a.note, e.textContent = i.saved || "Saved", window.dispatchEvent(new CustomEvent("cart:update", {
            bubbles: !0,
            detail: {
              cart: a
            }
          })), this.updateUIText(), this.scheduleHide();
        } catch (t) {
          console.error(t), e.textContent = i.error || "Error", setTimeout(() => {
            e.removeAttribute("disabled"), e.textContent = i.save || "Save";
          }, 2e3);
        } finally {
          document.dispatchEvent(new CustomEvent("spinner:hide", {
            detail: {
              source: "shopping-cart"
            }
          }));
        }
      }
      scheduleHide() {
        const {save: e} = this.elements, t = window.strings || {};
        this.restoreTimeout = setTimeout(() => {
          this.hideSaveButton(), setTimeout(() => {
            e.textContent = t.save || "Save", e.removeAttribute("disabled");
          }, 300);
        }, 2e3);
      }
      handleCartUpdate(e) {
        this.cart = e.detail?.cart || {}, document.activeElement !== this.elements.textarea && void 0 !== this.cart.note && this.cart.note !== this.elements.textarea.value && (this.elements.textarea.value = this.cart.note || "", 
        this.initialNote = this.cart.note), this.updateUIText();
      }
      updateUIText() {
        const e = window.strings || {}, t = !!(this.cart.note && this.cart.note.length > 0), n = this.elements.textarea.value, i = n.trim() !== (this.cart.note || "");
        this.elements.toggle && (this.elements.toggle.textContent = t ? e.edit || "Edit" : e.add || "Add");
        const {headerCount: a} = this.elements;
        if (a) {
          const e = n.length, t = this.elements.textarea.getAttribute("maxlength") || 250;
          a.textContent = `(${e}/${t})`, e > 0 ? a.classList.remove("opacity-0") : a.classList.add("opacity-0");
        }
        this.elements.cancel && (this.elements.cancel.textContent = i ? e.cancel || "Cancel" : e.close || "Close");
      }
      showSaveButton() {
        const {save: e} = this.elements;
        e.hasAttribute("disabled") || (e.removeAttribute("aria-hidden"), e.removeAttribute("tabindex"));
      }
      hideSaveButton() {
        const {save: e} = this.elements;
        e.setAttribute("aria-hidden", "true"), e.setAttribute("tabindex", "-1");
      }
      updateAccordionInert() {
        const {checkbox: e, accordion: t} = this.elements;
        e && t && (e.checked ? t.removeAttribute("inert") : t.setAttribute("inert", ""));
      }
      addEventListeners() {
        const {textarea: e, save: t, checkbox: n} = this.elements;
        e.addEventListener("input", this.handleInputChange), t.addEventListener("click", this.handleSaveClick), 
        window.addEventListener("cart:update", this.handleCartUpdate), window.addEventListener("cart:change", this.handleCartUpdate), 
        n && n.addEventListener("change", this.handleToggleChange);
      }
      removeEventListeners() {
        const {textarea: e, save: t, checkbox: n} = this.elements;
        e.removeEventListener("input", this.handleInputChange), t.removeEventListener("click", this.handleSaveClick), 
        window.removeEventListener("cart:update", this.handleCartUpdate), window.removeEventListener("cart:change", this.handleCartUpdate), 
        n && n.removeEventListener("change", this.handleToggleChange);
      }
    });
  })();
}();